import axios from "axios";
import GlobalVariables from "./globalVariables";

// import EventSource from "eventsource";
class Organization {
  static getEndpoints() {
    return {
      getOrganizations: "/api/user/organizations",
    };
  }

  static async getOrganizations(userId) {
    const ENDPOINT =
      GlobalVariables.getCloudRunAPIURL() +
      Organization.getEndpoints().getOrganizations;
    const response = await axios.get(ENDPOINT, {
      params: {
        uid: userId,
      },
    });
    return response.data;
  }
}

export default Organization;
